import React from 'react';
import {useStyles, Amount, Coin} from './helper';
import {translate} from '../../dictionaries'
const Content = ({handleSetIsShowModal, isShowModal, handleAddToHomeScreen}) => {
    const classes = useStyles();

    return (
        <div className={classes.root} style={{paddingTop: 50}}>
             <div className={classes.pl100} onClick={() => {
                handleSetIsShowModal(!isShowModal);
                handleAddToHomeScreen();
             }} style={{marginBottom: 330}}>      
                <div className={classes.wrapBtn}>
                    <span>{translate('common.registration')}</span>
                </div>
            </div>
            <div className={classes.wrapCoin}>
                <Coin />
            </div>
            <span className={classes.to}>
                {translate('common.after')} <br/>{translate('common.before')}
            </span>
     
            <div className={classes.amount}>
                <span className={classes.amountText}>
                    {translate('common.amount')}
                </span>
                <Amount className={classes.amountIcon}/>
            </div>
            
            <span className={classes.firstDeposit}>
            {translate('common.bonus2')}
            </span>
           
        </div>
    )
}

export default Content;